import type {FieldRootKeys} from 'schemaDefinition/functions/types';
import type {Part, PartName} from 'schemaDefinition/types';

export const getFieldRootKeys = (
  schemaKey: string | undefined,
  noLabel: boolean | undefined,
  key: Part['key'] | undefined,
  name: PartName | undefined,
): FieldRootKeys | undefined => {
  return noLabel || !(key || name)
    ? undefined
    : {
        schemaScoped: schemaKey
          ? `form.${schemaKey}.field.${key ?? name}`
          : undefined,
        global: `form.global.field.${key ?? name}`,
      };
};
